// extracted by mini-css-extract-plugin
export default {"blur":"blur_component_blur__buDqW","contactsButton":"blur_component_contactsButton__V6wtJ"};